<template>
  <div id="app">
    <Header />
    <router-view class="animate__animated  animate__fadeIn" />
    <Footer />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'app',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
@font-face {
  font-family: Bellefair;
  src: url("./assets/fonts/Bellefair.otf") format("opentype");
}
.heading {
  color: rgba(104,104,104,0.6);
  font-family: 'Montserrat', Arial, Helvetica, 'Nimbus Sans L', sans-serif;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  text-decoration: none;
}
body {
  background-color: '#eaeaea' !important;
}
#app {

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.modal-backdrop {
  z-index: -1 !important;
}
</style>
